import { useStationThumbnailBrand } from '../hooks/useStationThumbnailBrand';
import { useThumbnailForSegment } from '../hooks/useThumbnailForSegment';
import {
  generateFallbackThumbnailDisplayInfo,
  getThumbnailFrameIndexFromOffsetSeconds,
  resolveThumbnailMetadata,
} from '../utils';
import { LoadingThumbnail } from './LoadingThumbnail';
import { PreloadedThumbnail } from './PreloadedThumbnail';

interface Props {
  stationId: string;
  segmentId: number;
  offsetSeconds?: number;
  animated?: boolean;
  targetHeight?: number;
}

export function SegmentThumbnail({
  stationId,
  segmentId,
  animated,
  offsetSeconds = 0,
  targetHeight,
}: Props) {
  const thumb = useThumbnailForSegment(stationId, segmentId);
  const { logoUrl, stationName } = useStationThumbnailBrand(stationId);

  // Only show loader if we don't have any thumbnail data (initial load)
  // When segmentId changes, placeholderData keeps the previous thumbnail visible
  if (thumb.isLoading && !thumb.info) {
    return (
      <LoadingThumbnail
        metadata={generateFallbackThumbnailDisplayInfo()}
        targetHeight={targetHeight}
        logoUrl={logoUrl}
        stationName={stationName}
      />
    );
  }

  if (!thumb.info) {
    return null;
  }

  const metadata = resolveThumbnailMetadata([thumb.info.metadata]);

  return (
    <PreloadedThumbnail
      url={thumb.info.thumbnailUrl}
      metadata={metadata}
      offset={getThumbnailFrameIndexFromOffsetSeconds(offsetSeconds, metadata)}
      animated={animated}
      targetHeight={targetHeight}
      logoUrl={logoUrl}
      stationName={stationName}
    />
  );
}
